import pino from 'pino';

// Determine if the app is running in production
const isProduction = process.env.NODE_ENV === 'production';

// Create the logger instance
const logger = pino({
  level: isProduction ? 'info' : 'debug', // Set log level based on the environment
  base: null, // Remove pid, hostname, etc.
  timestamp: pino.stdTimeFunctions.isoTime, // Use ISO time format for timestamps
  transport: !isProduction ? {
    target: 'pino-pretty',
    options: {
      colorize: true, // Colorize logs for better readability in development
      translateTime: 'SYS:standard', // Standardize time format in logs
      ignore: 'pid,hostname', // Ignore process ID and hostname in logs
    },
  } : undefined,
});

export default logger;
